module.exports = __webpack_public_path__ + "assets/2.0159d7ed.png";